import { EnvironmentProviders, ModuleWithProviders, Provider } from '@angular/core';
import { CookieModule } from 'ngx-cookie';

import {
  ComponentsModule,
  DPUActionsReducer,
  PARAMETER_INFOS_TOKEN,
  PreferenceLoader,
  PreferenceLocalLoader,
  PreferenceModule,
  StickynoteModule,
  StoreModule,
  TOOLBAR_SERVICE_TOKEN,
  ToolbarActionsReducer,
  ToolbarActionType,
  ToolbarModule,
} from '@olympus/ngx-shared';
import {
  FILE_BROWSER_ACCEPTED_EXTENSIONS,
  FILE_BROWSER_ENV_CONFIG,
  FILE_BROWSER_OPEN_DRIVE_FILE_ACTION,
  FILE_BROWSER_OPEN_LOCAL_FILE_ACTION,
  FileBrowserModule } from 'shared-business-angular/desktop-file-browser';
import { I18nLocalStorageService, I18nModule, I18nStorageService } from 'shared-modules-angular/i18n';

import {
  acquisitionUnitParameters,
  analysisParameters,
  awsParameters,
  beamsParameters,
  calibrationParameters,
  dacParameters,
  encodersPositionParameters,
  gatesParameters,
  mechanicalSettingsParameters,
  tcgParameters,
  thicknessParameters,
  utSettingsParameters,
} from '../fields';
import { tilingCanvasParameters } from '../fields/tiling-canvas.parameters';
import { DPUReducer } from './core/reducers/dpu/dpu.reducer';
import { ElectronReducer } from './core/reducers/electron/electron.reducer';
import { FileDialogReducer } from './core/reducers/file-dialog/file-dialog.reducer';
import { SaveReducer } from './core/reducers/save/save.reducer';
import {
  browseFileAcceptedExtensionsFactory,
  browseFileEnvConfigFactory,
  browseFileOpenDriveFileActionFactory,
  browseFileOpenLocalFileActionFactory,
} from './modules/file-browser/file-browser-module-factory';
import { LicenseModule } from './modules/license/license.module';
import { RibbonQuickActionsComponent } from './modules/ribbon/ribbon-quick-actions/ribbon-quick-actions.component';
import { SharedModule } from './shared/shared.module';

export const sharedModules: any[] = [
  // from ngx-shared
  StickynoteModule,
  ComponentsModule.forChild(),
  ToolbarModule.forChild(),
  SharedModule.forChild(),

  // from windview
  RibbonQuickActionsComponent,
  LicenseModule.forChild(),
  FileBrowserModule.forChild(),
];

export const sharedModulesWithProviders: ModuleWithProviders<any>[] = [
  I18nModule.forRoot({
    storageProvider: {
      provide: I18nStorageService,
      useExisting: I18nLocalStorageService,
    },
    defaultLang: 'en',
    languages: ['en'],
  }),
  FileBrowserModule.forRoot({
    acceptedExtensions: {
      provide: FILE_BROWSER_ACCEPTED_EXTENSIONS,
      useFactory: browseFileAcceptedExtensionsFactory,
    },
    openLocalFileAction: {
      provide: FILE_BROWSER_OPEN_LOCAL_FILE_ACTION,
      useFactory: browseFileOpenLocalFileActionFactory,
    },
    openDriveFileAction: {
      provide: FILE_BROWSER_OPEN_DRIVE_FILE_ACTION,
      useFactory: browseFileOpenDriveFileActionFactory,
    },
    envConfig: {
      provide: FILE_BROWSER_ENV_CONFIG,
      useFactory: browseFileEnvConfigFactory,
    },
  }),
  LicenseModule.forRoot(),
  SharedModule.forRoot(),
  ToolbarModule.forRoot(),
  PreferenceModule.forRoot({
    loader: {
      provide: PreferenceLoader,
      useClass: PreferenceLocalLoader,
    },
  }),
  StoreModule.forRoot([
    DPUReducer,
    ElectronReducer,
    FileDialogReducer,
    DPUActionsReducer,
    ToolbarActionsReducer,
    SaveReducer,
  ]),
  CookieModule.withOptions(),
];

export const sharedModulesProviders: (Provider | EnvironmentProviders)[] = [
  {
    provide: TOOLBAR_SERVICE_TOKEN,
    useValue: [
      ToolbarActionType.SELECT,
      ToolbarActionType.RECTANGLE_ZONE,
      ToolbarActionType.CIRCLE,
      ToolbarActionType.FREE_ZONE,
      ToolbarActionType.MEASURE,
      ToolbarActionType.STICKY_NOTE,
      ToolbarActionType.DRAW,
      ToolbarActionType.ZOOM,
      ToolbarActionType.HAND,
    ],
  },
  {
    provide: PARAMETER_INFOS_TOKEN,
    useValue: [
      acquisitionUnitParameters,
      analysisParameters,
      beamsParameters,
      calibrationParameters,
      encodersPositionParameters,
      gatesParameters,
      mechanicalSettingsParameters,
      tcgParameters,
      utSettingsParameters,
      dacParameters,
      thicknessParameters,
      awsParameters,
      tilingCanvasParameters,
    ],
  },
];
